export const AVERAGE_BLOCK_TIME = 13.4;

export const AVERAGE_BLOCK_TIME_BSC = 3.02;
